var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCategoryStandUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.153 12.383 6.748 8.925c.371.491.323 1.179-.112 1.614l-.869.869a1.233 1.233 0 0 1-1.613.112L8.38 17.155m20.952-2.488-2.328-2.328a3.245 3.245 0 1 0-4.59 4.59l3.289 3.29a3.354 3.354 0 0 1-4.743 4.743l-1.606-1.607M8.068 17.468l5.401-5.401a5.402 5.402 0 0 0-10.802.001 5.4 5.4 0 0 0 5.401 5.4Z",
  stroke: "#717680",
  strokeWidth: 2.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcCategoryStandUp;